import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { removeUndoMarker, showUndoMarker } from "./undoMarker";

const DirectSelectPolygon = { ...MapboxDraw.modes.direct_select };

const originalOnSetup = DirectSelectPolygon.onSetup;
const originalOnVertex = DirectSelectPolygon.onVertex;
const originalOnMouseUp = DirectSelectPolygon.onMouseUp;
const originalOnMouseDown = DirectSelectPolygon.onMouseDown;
const originalOnStop = DirectSelectPolygon.onStop;

const savePreviousCoordinates = (state) => {
    const coords = JSON.parse(JSON.stringify(state.feature.getCoordinates()));
    const ring = coords[0];
    if (ring.length > 1 && ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]) {
        ring.pop();
    }
    state.previousCoordinates = coords;
};

DirectSelectPolygon.onSetup = function (options) {
    const state = originalOnSetup.call(this, options);
    state.draggedCoordPath = null;
    state.mapClickHandler = (e) => {
        if (state.undoMarker && !state.undoMarker.getElement().contains(e.target)) {
            removeUndoMarker(state);
        }
    };
    this.map.getContainer().addEventListener("mousedown", state.mapClickHandler, true);
    return state;
};

DirectSelectPolygon.onVertex = function (state, e) {
    savePreviousCoordinates(state);
    state.draggedCoordPath = e.featureTarget.properties.coord_path;
    originalOnVertex.call(this, state, e);
};

DirectSelectPolygon.onMidpoint = function (state, e) {
    savePreviousCoordinates(state);
    state.draggedCoordPath = e.featureTarget.properties.coord_path;

    this.startDragging(state, e);
    const properties = e.featureTarget?.properties;
    state.feature.addCoordinate(properties.coord_path, properties.lng, properties.lat);
    state.selectedCoordPaths = [properties.coord_path];
};

DirectSelectPolygon.onMouseUp = function (state, e) {
    if (originalOnMouseUp) originalOnMouseUp.call(this, state, e);

    if (state.draggedCoordPath && state.previousCoordinates) {
        const coords = state.feature.getCoordinates()[0];
        const pathParts = state.draggedCoordPath.split(".");
        const idx = parseInt(pathParts[pathParts.length - 1], 10);
        const coord = coords[idx] || coords[0];
        this.map.fire("draw.update", {
            features: [state.feature.toGeoJSON()],
            action: "change_coordinates",
        });
        showUndoMarker(this.map, state, coord);
    }
    state.draggedCoordPath = null;
};

DirectSelectPolygon.onDrag = function (state, e) {
    if (state.canDragMove !== true) return;
    state.dragMoving = true;
    e.originalEvent.stopPropagation();

    const delta = {
        lng: e.lngLat.lng - state.dragMoveLocation.lng,
        lat: e.lngLat.lat - state.dragMoveLocation.lat,
    };

    if (state.selectedCoordPaths.length > 0) {
        this.dragVertex(state, e, delta);
    }

    state.dragMoveLocation = e.lngLat;
};

DirectSelectPolygon.onMouseMove = function (state, e) {
    const isFeature = e.featureTarget?.properties?.active === "true" && e.featureTarget?.properties?.meta === "feature";
    const onVertex = e.featureTarget?.properties?.meta === "vertex";
    const noCoords = state.selectedCoordPaths.length === 0;

    if ((isFeature && noCoords) || (onVertex && !noCoords)) {
        this.updateUIClasses({ mouse: "move" });
    } else {
        this.updateUIClasses({ mouse: "none" });
    }

    this.stopDragging(state);
    return true;
};

DirectSelectPolygon.onMouseOut = function () {
    return true;
};

DirectSelectPolygon.onMouseDown = function (state, e) {
    if (originalOnMouseDown) originalOnMouseDown.call(this, state, e);

    const props = e.featureTarget?.properties;

    if (!props) return;
    if (props.parent !== state.featureId) return;

    savePreviousCoordinates(state);

    state.dragHandle = {
        handleType: props.handleType,
        handleId: props.handleId,
    };
    state.isDragging = true;
};

DirectSelectPolygon.onStop = function (state) {
    this.map.getContainer().removeEventListener("mousedown", state.mapClickHandler, true);
    removeUndoMarker(state);
    if (originalOnStop) originalOnStop.call(this, state);
};

DirectSelectPolygon.onTrash = function (state) {
    this.deleteFeature([state.featureId], { silent: false });
    this.changeMode("simple_select");
};

DirectSelectPolygon.onFeature = function () {};

export default DirectSelectPolygon;
